export default "__VITE_ASSET__Cx19maK8__"